export interface IInvoiceDetailBaseResponse {
  invoiceNumber: string;
  dueDate: string;
  usageAmount: number;
  rate: string;
  generationCharge: number;
  billingSuccessful: boolean;
  approvalDate: string;
  invoiceType: string;
  balanceDue: number;
  emailAddress: string;
  pastDue: number;
  note: string;
  documentKey: string;
  billingFee: string;
}

export class InvoiceDetailBaseResponse implements IInvoiceDetailBaseResponse {
  invoiceNumber: string;
  dueDate: string;
  usageAmount: number;
  rate: string;
  generationCharge: number;
  billingSuccessful: boolean;
  approvalDate: string;
  invoiceType: string;
  balanceDue: number;
  emailAddress: string;
  pastDue: number;
  note: string;
  documentKey: string;
  billingFee: string;
}
